const { getElements } = window.BAO.Utils

class WishlistPage extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.populateLists = this.populateLists.bind(this)
    this.handleWishlistChange = this.handleWishlistChange.bind(this)
    this.setupWishlist = this.setupWishlist.bind(this)

    this.handleRemoveItem = this.handleRemoveItem.bind(this)

    this.getCurrentWishlistDetails = this.getCurrentWishlistDetails.bind(this)

    this.wishlistError = this.wishlistError.bind(this)

    this.listeners.add(document, 'click', this.handleWishlistChange)
    this.listeners.add(document, 'click', this.handleRemoveItem)

    this.handleBack = this.handleBack.bind(this)
    this.els.back.elements.forEach(backEl => {
      this.listeners.add(backEl, 'click', this.handleBack)
    })

    window.SwymCallbacks = window.SwymCallbacks || []
    window.SwymCallbacks.push(swat => {
      window._swat.fetchLists({
        callbackFn: this.populateLists,
        errorFn: this.wishlistError,
      })
    })
  }

  populateLists (lists) {
    this.els.delete.element.setAttribute('aria-hidden', lists.length < 2)

    this.els.wishlists.element.innerHTML = ''

    if (lists.length > 0) {
      lists.forEach(async (list, index) => {
        if (index === 0) {
          this.els['current-wishlist-text'].element.setAttribute(
            'data-wishlist-id',
            list.lid,
          )
        }

        const homeElementHTML = await this.createHomeElement(list, index)

        this.els.wishlists.element.innerHTML += homeElementHTML
      })

      this.els['page-loading'].element.setAttribute('aria-hidden', true)
      this.els['page-home'].element.setAttribute('aria-hidden', false)
      this.els['page-empty'].element.setAttribute('aria-hidden', true)
      this.els['page-wishlist'].element.setAttribute('aria-hidden', true)
    } else {
      this.els['page-loading'].element.setAttribute('aria-hidden', true)
      this.els['page-home'].element.setAttribute('aria-hidden', true)
      this.els['page-empty'].element.setAttribute('aria-hidden', false)
      this.els['page-wishlist'].element.setAttribute('aria-hidden', true)
    }
  }

  createHomeElement (list, index) {
    let cardImages = ''

    return Promise.all(
      list.listcontents.map(async value => {
        const productHandle = value.du.split('/').slice(-1)

        const productData = await window.BAO.Utils.fetchProductData(
          productHandle[0],
        )

        return productData
      }),
    ).then(res => {
      const productList = list.listcontents.filter((_, idx) => res[idx])

      if (list.cnt > 0) {
        cardImages = '<div class="wsh-Card_Images">'
        productList.slice(0, 3).forEach(listItem => {
          if (listItem.iu) {
            cardImages += `<img class="wsh-Card_Image" src="${listItem.iu}" alt="${listItem.dt}">`
          }
        })

        cardImages += '</div>'
      }

      const html = `<div class="wsh-Card">
        <button
          type="button"
          class="wsh-Card_Title fz-18_144"
          data-wishlist-page-el="wishlist-change-trigger"
          data-wishlist-id="${list.lid}"
        >
          ${list.lname}
        </button>
        <p class="wsh-Card_Text fz-14_171">${productList.length} ${
        list.cnt === 1
          ? window.theme.wishlist.item
          : window.theme.wishlist.items
      }</p>
  
        ${cardImages}
  
        <div class="wsh-Card_Buttons">
        ${
          list.cnt === 0
            ? `<a href="/collections/all" class="wsh-Card_Button btn-Button btn-Button-outline">${window.theme.wishlist.addToWishlist}</a>`
            : `<button type="button" class="wsh-Card_Button btn-Button btn-Button-outline" data-wishlist-page-el="wishlist-change-trigger" data-wishlist-id="${list.lid}">
              ${window.theme.wishlist.viewWishlist}
            </button>`
        }
        </div>
      </div>`

      return html
    })
  }

  handleWishlistChange (event) {
    const trigger = event.target.closest(
      '[data-wishlist-page-el="wishlist-change-trigger"]',
    )

    if (!trigger) return

    this.els['current-wishlist-text'].element.setAttribute(
      'data-wishlist-id',
      trigger.dataset.wishlistId,
    )

    this.getCurrentWishlistDetails()

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  getCurrentWishlistDetails () {
    const listConfig = {
      lid: this.els['current-wishlist-text'].element.dataset.wishlistId,
    }

    window._swat.fetchListDetails(
      listConfig,
      this.setupWishlist,
      this.wishlistError,
    )
  }

  async setupWishlist (wishlist) {
    if (this?.els?.share?.exists) {
      this.els.share.element.setAttribute('data-wishlist-id', wishlist.list.lid)
    }
    this.els.delete.element.setAttribute('data-wishlist-id', wishlist.list.lid)

    getElements('[data-wishlist-page-el="wishlist-change-trigger"]').forEach(
      el => {
        el.setAttribute(
          'aria-current',
          el.dataset.wishlistId === wishlist.list.lid,
        )
      },
    )

    const productCardHTML = await this.getAllProductCardHTML(wishlist)
    this.els[
      'current-wishlist-text'
    ].element.textContent = `${wishlist.list.lname} (${this.currentWishlistCount})`
    this.els.products.element.innerHTML = productCardHTML

    if (wishlist.list.cnt > 0) {
      this.els['panel-list'].element.setAttribute('aria-hidden', false)
      this.els['panel-empty'].element.setAttribute('aria-hidden', true)
    } else {
      this.els['panel-list'].element.setAttribute('aria-hidden', true)
      this.els['panel-empty'].element.setAttribute('aria-hidden', false)
    }

    this.els['page-loading'].element.setAttribute('aria-hidden', true)
    this.els['page-home'].element.setAttribute('aria-hidden', true)
    this.els['page-empty'].element.setAttribute('aria-hidden', true)
    this.els['page-wishlist'].element.setAttribute('aria-hidden', false)
  }

  async getAllProductCardHTML (wishlist) {
    const productCardHTML = await Promise.all(
      wishlist.items.map(
        async (product, index) => await this.getProductCardHTML(product, index),
      ),
    )

    this.currentWishlistCount = productCardHTML.filter(Boolean).length
    return productCardHTML.filter(Boolean).join('')
  }

  async getProductCardHTML (product, index) {
    return window.BAO.sectionRenderer
      .fetchSingle(
        'wishlist-product-card',
        `${product.du}?variant=${product.epi}`,
      )
      .then(res => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)
        const myself = newDOM.querySelector('article')

        if (myself) {
          const itemClasses =
            (index + 1) % 2
              ? 'wsh-Page_Item wsh-Page_Item-left'
              : 'wsh-Page_Item wsh-Page_Item-right'

          return `<div class="${itemClasses}">${myself.outerHTML.replace(
            'data-wishlist-page-el="remove"',
            `data-wishlist-page-el="remove" data-product-id="${product.empi}" data-variant-id="${product.epi}" data-product-url="${product.du}"`,
          )}</div>`
        }
      })
      .catch(() => {
        return null
      })
  }

  handleRemoveItem (event) {
    const trigger = event.target.closest('[data-wishlist-page-el="remove"]')

    if (!trigger) return

    const lid = this.els['current-wishlist-text'].element.dataset.wishlistId

    const product = {
      epi: trigger.dataset.variantId,
      empi: trigger.dataset.productId,
      du: trigger.dataset.productUrl,
    }

    window._swat.deleteFromList(
      lid,
      product,
      this.getCurrentWishlistDetails,
      this.wishlistError,
    )
  }

  handleBack () {
    window._swat.fetchLists({
      callbackFn: this.populateLists,
      errorFn: this.wishlistError,
    })
  }

  wishlistError (errorMessage) {
    // eslint-disable-next-line
    console.log(`Wishlist error: ${errorMessage}`)

    this.els['page-loading'].element.setAttribute('aria-hidden', true)
    this.els['page-home'].element.setAttribute('aria-hidden', true)
    this.els['page-empty'].element.setAttribute('aria-hidden', false)
    this.els['page-wishlist'].element.setAttribute('aria-hidden', true)
  }
}

if (!customElements.get('wishlist-page')) {
  customElements.define('wishlist-page', WishlistPage)
}
